import { ProjectActionType, IProjectState, ProjectAction } from "../types/projectDataSQP"

const initialState: IProjectState = {
  projectDataSQP: {},
  loading: false,
  error: null,
}

export const projectDataReducer = (
  state: IProjectState = initialState,
  action: ProjectAction
): IProjectState => {
  switch (action.type) {
    case ProjectActionType.FETCH_PROJECT_DATA_SQP:
      return { ...state, loading: true }
    case ProjectActionType.FETCH_PROJECT_DATA_SQP_SUCCESS:
      return { ...state, projectDataSQP: action.payload, loading: false }
    case ProjectActionType.FETCH_PROJECT_DATA_SQP_ERROR:
      return { ...state, error: action.payload, loading: false }
    default:
      const exhaustiveCheck: never = action
      return state
  }
}

export default projectDataReducer
